"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.game = exports.SYGame = exports.SYAchievements = void 0;
const SYMainScene_1 = require("./SYMainScene");
const SYPreloadScene_1 = require("./SYPreloadScene");
const KHPersistentReference_1 = require("./KH/References/KHPersistentReference");
const KHGame_1 = require("./KH/KHGame");
const KHAchievements_1 = require("./KH/KHAchievements");
const config = {
    type: Phaser.AUTO,
    backgroundColor: "#FFFFFF",
    scale: {
        width: 960,
        height: 600,
    },
    input: {
        gamepad: true,
        mouse: {
            preventDefaultWheel: false
        },
    },
    parent: "phaser-game",
    dom: {
        createContainer: true
    },
    version: "1.0.0",
    scene: [SYPreloadScene_1.SYPreloadScene, SYMainScene_1.SYMainScene]
};
var SYAchievements;
(function (SYAchievements) {
    SYAchievements["AreYouHappy"] = "sisyphus_happy";
})(SYAchievements = exports.SYAchievements || (exports.SYAchievements = {}));
class SYGame extends KHGame_1.KHGame {
    constructor(config, khConfig) {
        super(config, khConfig);
        this.width = Number(this.config.width);
        this.height = Number(this.config.height);
        this.achievements = new KHAchievements_1.default();
        this.seed = new KHPersistentReference_1.KHPersistentReference(-1, true);
        this.storageManager.registerAll({
            [KHAchievements_1.default.MENAGERIE_KEY]: this.achievements,
            'kh.sisyphus': {
                'seed': this.seed,
            }
        });
    }
}
exports.SYGame = SYGame;
exports.game = new SYGame(config, { scaleMode: KHGame_1.KHScaleMode.NoScale, alwaysMaxScale: true });
